module.exports = __webpack_public_path__ + "img/anxiety-icon-4.c3ac5171.svg";